import { Tooltip } from '@material-ui/core'
import { renderMoney } from 'common/services/util'
import React, { useState, useEffect } from 'react'

const CheckBudget = ({ props, handleChangeBudget, maxImportance, isPayed }) => {
    const accepted = props.budgetAccept ? parseInt(props.budgetAccept) === 1 : false
    const [checked, setChecked] = useState(accepted)

    useEffect(() => {
        setChecked(props.budgetAccept ? parseInt(props.budgetAccept) === 1 : false)
    }, [props.budgetAccept])

    const handleClick = () => {
        if (props.budget == null || props.budget === '') return
        const newValue = checked ? 0 : 1
        setChecked(!checked)
        handleChangeBudget(props, newValue)
    }

    const textStyle = {
        fontWeight: maxImportance || isPayed ? 'bold' : 'initial',
        fontSize: isPayed ? '0.975rem' : '0.875rem',
        color: isPayed ? '#3f51b5' : 'initial'
    }

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center', paddingRight: '10px' }}>
            { (props.budget != null && props.budget !== '') &&
                <Tooltip title={checked ? 'Click para rechazar presupuesto' : 'Click para aceptar presupuesto'}>
                    <span
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}
                        onClick={handleClick}
                    >
                        <span style={textStyle}>{ renderMoney(props.budget) }</span>
                        { checked &&
                            <span style={{
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                background: '#10b981',
                                border: '2px solid white',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '10px',
                                color: 'white',
                                fontWeight: 'bold',
                                flexShrink: 0
                            }}>✓</span>
                        }
                    </span>
                </Tooltip>
            }
        </div>
    )
}

export default CheckBudget